export default "__VITE_ASSET__BRaf2Oih__"